var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMAndO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 50.62C20.11 50.62 15.43 49.62 12.45 47.31C11.31 46.41 9.14 48.09 7.32 45.62C4.89 42.33 5.74 38.96 7.41 38.06C9.41 36.98 11.15 39.27 11.15 39.27C8.20001 22.56 15 12.21 30 12.21C45 12.21 51.8 22.56 48.85 39.27C48.85 39.27 50.6 36.98 52.59 38.06C54.26 38.96 55.11 42.33 52.68 45.62C50.86 48.09 48.68 46.41 47.55 47.31C44.57 49.65 39.89 50.62 30 50.62Z",
    fill: "#FFE2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 25.31C25.7601 25.31 22.7701 24.45 19.2501 25.12C17.9415 25.3986 16.7609 26.0996 15.8899 27.1152C15.019 28.1307 14.506 29.4043 14.4301 30.74C14.6301 26.68 16.2301 22.26 19.2501 21.3C19.7566 21.1318 20.2864 21.044 20.8201 21.04C24.4101 21.04 26.2701 25.31 30.0001 25.31Z",
    fill: "#FFE2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 21.3001C43.75 22.3001 45.37 26.6801 45.58 30.7401C45.4986 29.4045 44.9824 28.1323 44.1104 27.1176C43.2383 26.1029 42.0581 25.4013 40.75 25.1201C37.22 24.4501 34.24 25.3101 30 25.3101C34.24 25.3101 36.06 19.8001 40.75 21.3001Z",
    fill: "#FFE2C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.44 13.24C37.36 15.01 34.06 16.43 30 16.43C25.94 16.43 22.65 15.01 22.57 13.24C12.83 16.24 8.75 25.63 11.16 39.24C11.26 39.1 11.37 38.97 11.48 38.83C13.07 36.83 14.09 35 14.43 30.71C14.63 26.65 16.23 22.23 19.25 21.27C19.7565 21.1017 20.2863 21.014 20.82 21.01C24.41 21.01 26.27 25.28 30 25.28C34.24 25.28 36.06 19.77 40.75 21.28C43.75 22.28 45.37 26.66 45.58 30.72C45.91 35.01 46.93 36.81 48.52 38.84L48.85 39.25C51.26 25.63 47.17 16.24 37.44 13.24Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 16.4299C34.0601 16.4299 37.3601 15.0099 37.4401 13.2399C32.5785 11.8666 27.4316 11.8666 22.5701 13.2399C22.6501 15.0099 25.9401 16.4299 30.0001 16.4299Z",
    fill: "#FFE2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAndO);
export default __webpack_public_path__ + "static/media/m-and-o.ab897ee2ad63ca0473f6abe8ff3096a4.svg";
export { ForwardRef as ReactComponent };